import React, { useState } from "react";

export const sectionHasInformation = (appointment, fields) => fields.some(field => String(appointment?.[field] ?? "").trim().length > 0);

export default function AppointmentSection({title, initiallyOpen, hasInformation, className = "", children}) {
  const [open,setOpen]=useState(initiallyOpen);
  return <details className={`appointment-section ${className}`} open={open} onToggle={event=>setOpen(event.currentTarget.open)}>
    <summary><span>{title}</span>{hasInformation !== undefined && <small>{hasInformation ? "Information added" : "No information"}</small>}</summary>
    <div className="appointment-section-body">{children}</div>
  </details>;
}
